define('home/views/ModeratedForumsModuleView',[
    'backbone-marionette',

    'home/views/FetchingView',
    'home/views/ModeratedForumsModuleItemView',

    'home/templates/moderatedForumsModule',
], function (
    Marionette,

    FetchingView,
    ModeratedForumsModuleItemView,

    moderatedForumsModuleTemplate
) {
    'use strict';

    /**
     * Shows the first 3 forums a user is moderating and
     * links to the moderation page.
     *
     * Expects a ForumCollection
     */
    var ModeratedForumsModuleView = Marionette.CompositeView.extend({
        template: moderatedForumsModuleTemplate,
        itemView: ModeratedForumsModuleItemView,
        itemViewContainer: '[data-role=moderated-forums]',

        templateHelpers: function () {
            return {
                moderatedForumsCount: this.collection.length,
            };
        },

        addItemView: function (item, ItemView, index) {
            if (index > this.constructor.FORUMS_MAX - 1)
                return;

            return Marionette.CompositeView.prototype.addItemView.call(this, item, ItemView, index);
        },

        emptyView: function () {
            return new FetchingView({
                className: 'spinner-small',
            });
        },
    }, {
        FORUMS_MAX: 3,
    });

    return ModeratedForumsModuleView;
});

